import React from "react";

class WelcomeLayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      logo: this.props.logo,
      footer: this.props.footer
    }
  }

  getLogo() {
    const institutionId = this.getInstitutionId();
    if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
      return `https://www.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    } else {
      return `https://pruebas.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    }
  }

  getInstitutionId() {
    const institutions = {
      dev: {
        bac: 711,
        colsubsidio: 707,
        funcol: 702
      },
      prod: {
        bac: 735,
        colsubsidio: 707,
        funcol: 702
      }
    }
    const env = process.env.PUBLIC_URL.indexOf('appsprod') >= 0?"prod":"dev";
    return institutions[env][Object.keys(institutions[env]).filter(key =>{
      return window.location.pathname.includes(key);
    })[0]];
  }

  render() {
    return (
      <div className="card card-signin my-5 col-sm-6 border-left-0 " style={{background: "#b5b6b5"}} >
        <img alt="colsubsidio" className="justify-content-center align-self-center" style={{maxWidth:"300px", paddingTop:"10%"}}
          src={this.getLogo()}/>
        
        <div className="card-body align-self-center">
            <h2 className="card-title row justify-content-center align-self-center text-white">¡Bienvenido!</h2>
            {this.props.message?
              <h6 className="justify-content-justify text-white text-justify">{this.props.message}</h6>
        :<></>}
        </div>
        
      </div>

    )
  }
}

export default WelcomeLayer;
